import { registerPrimitives5bvy9r84uuq6 as registerPrimitives } from './PrimitiveRenderers.mjs';
import { registerDateTimeskcii0b01r679 as registerDateTimes } from './DateTimeRenderers.mjs';
import { registerSpecialTypes24867s8682369 as registerSpecialTypes } from './SpecialTypeRenderers.mjs';
import { registerServerFile3pevtwdybn60v as registerServerFile } from './ServerFileRenderer.mjs';
import { registerSortPatho3x58i9bfjpo as registerSortPath } from './SortPathRenderer.mjs';
import { registerCondition1a18tvlf3klb0 as registerCondition } from './ConditionRenderer.mjs';
import { registerModification41dip2d4pqgm as registerModification } from './ModificationRenderer.mjs';
import { registerForeignKeytbmwo3p8dy1n as registerForeignKey } from './ForeignKeyRenderer.mjs';
import { registerEnumorzz7czqky6e as registerEnum } from './EnumRenderer.mjs';
import { registerWrapper35q0amaxu7r44 as registerWrapper } from './WrapperRenderer.mjs';
import { registerMySealed3nr0obmvs3xjq as registerMySealed } from './MySealedRenderer.mjs';
import { registerVirtualSealed20oawc47pq9zf as registerVirtualSealed } from './VirtualSealedRenderer.mjs';
import { registerNormalSealedl18cy3gxoyfw as registerNormalSealed } from './NormalSealedRenderer.mjs';
import { registerSingletonObject3kqw43jd6n61l as registerSingletonObject } from './ObjectRenderer.mjs';
import { registerCollections1oekufk991i5n as registerCollections } from './ListRenderer.mjs';
import { registerSet1ljcp26q8gzm8 as registerSet } from './SetRenderer.mjs';
import { registerEnumSet1xu98s984a356 as registerEnumSet } from './EnumSetRenderer.mjs';
import { registerMap2u9untf2jo1ee as registerMap } from './MapRenderer.mjs';
import { registerTableop0oy9jchn1j as registerTable } from './TableRenderer.mjs';
import { registerObject1ttoxtvhwoaoe as registerObject } from './DataClassRenderer.mjs';
import { registerNullable3t9rzzkytq3g1 as registerNullable } from './NullableRenderer.mjs';
import { registerJson8qalkxxl4iau as registerJson } from './JsonRenderer.mjs';
import { registerHex4yx9p1vld97r as registerHex } from './HexRenderers.mjs';
import { registerCsv2f0uur2hqp2nx as registerCsv } from './CsvRenderer.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function defaults(_this__u8e3s4) {
  registerPrimitives(_this__u8e3s4);
  registerDateTimes(_this__u8e3s4);
  registerSpecialTypes(_this__u8e3s4);
  registerServerFile(_this__u8e3s4);
  registerSortPath(_this__u8e3s4);
  registerCondition(_this__u8e3s4);
  registerModification(_this__u8e3s4);
  registerForeignKey(_this__u8e3s4);
  registerEnum(_this__u8e3s4);
  registerWrapper(_this__u8e3s4);
  registerMySealed(_this__u8e3s4);
  registerVirtualSealed(_this__u8e3s4);
  registerNormalSealed(_this__u8e3s4);
  registerSingletonObject(_this__u8e3s4);
  registerCollections(_this__u8e3s4);
  registerSet(_this__u8e3s4);
  registerEnumSet(_this__u8e3s4);
  registerMap(_this__u8e3s4);
  registerTable(_this__u8e3s4);
  registerObject(_this__u8e3s4);
  registerNullable(_this__u8e3s4);
  registerJson(_this__u8e3s4);
  registerHex(_this__u8e3s4);
  registerCsv(_this__u8e3s4);
}
//region block: exports
export {
  defaults as defaults3uorosiarf5y,
};
//endregion

//# sourceMappingURL=FormModule.defaults.mjs.map
